import { Link } from "react-router-dom";
import { waUrl, WA_GENERAL } from "../config/site";
import WhatsAppIcon from "./WhatsAppIcon";

export default function MobileCTA() {
  return (
    <div
      className="fixed inset-x-0 bottom-0 z-40 border-t border-obsidian/10 bg-ivory/95 backdrop-blur-lg md:hidden"
      data-testid="mobile-sticky-cta"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <div className="grid grid-cols-2">
        <Link
          to="/bulk-quote"
          data-event="bulk_quote_click"
          data-testid="mobile-sticky-quote-btn"
          className="flex items-center justify-center gap-2 bg-cleef py-4 font-display text-sm font-bold uppercase tracking-[0.08em] text-white"
        >
          Get Bulk Quote
        </Link>
        <a
          href={waUrl(WA_GENERAL)}
          target="_blank"
          rel="noopener noreferrer"
          data-event="whatsapp_click"
          data-testid="mobile-sticky-whatsapp-btn"
          className="flex items-center justify-center gap-2 bg-obsidian py-4 font-display text-sm font-bold uppercase tracking-[0.08em] text-white"
        >
          <WhatsAppIcon className="h-4 w-4 text-[#25D366]" /> WhatsApp
        </a>
      </div>
    </div>
  );
}
